import { render, staticRenderFns } from "./MultiPHSTooltipDialog.vue?vue&type=template&id=6398ad46&scoped=true&"
import script from "./MultiPHSTooltipDialog.vue?vue&type=script&lang=js&"
export * from "./MultiPHSTooltipDialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiPHSTooltipDialog.vue?vue&type=style&index=0&id=6398ad46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398ad46",
  null
  
)

export default component.exports